import Vue from 'vue'
import Vuex from 'vuex'

import alert from './modules/alert'
import auth from './modules/auth'
import modals from './modules/modals'
import panels from './modules/panels'
import user from './modules/user'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    alert,
    auth,
    modals,
    panels,
    user
  },
  strict: process.env.NODE_ENV !== 'production'
})
